//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import throttle from 'lodash/throttle';
import { rando } from '@nastyox/rando.js';

import {
  easeInQuad,
  easeInOutSine
} from 'js-easing-functions';
import Button from '~/components/other/Button';
import { getArrForTitle, debounce } from '~/utils/utils';

export default {
  components: {
    Button
  },
  props: {
    mainImages: {
      type: Array,
      default: () => []
    },
    images: {
      type: Array,
      default: () => []
    },
    stats: {
      type: Array,
      default: () => []
    },
    defaultScroll: {
      type: Boolean,
      default: true
    },
    imgName: {
      type: String,
      required: false,
      default: ''
    },
    btns: {
      type: Array,
      required: false
    }
  },
  data: function () {
    return {
      scrollRatio: 1,
      scrollTop: 0,
      watchScroll: true,
      hideText: false,
      hideImages: false,
      // mainImage: this.mainImages[0],
      mainImageIndex: 0,
      timer: null,
      restarted: false,
      tabletAnchors: false,
      usedIphone: false,
      intersectionObserver: null
    }
  },
  beforeMount () {
    if (window) {
      this.mediaQuery = window.matchMedia('(max-width: 600px)')
      this.mediaQuery?.addEventListener ? this.mediaQuery.addEventListener('change', this.mediaHandler) : this.mediaQuery.addListener(this.mediaHandler)

      if (this.mediaQuery.matches) {
        this.tabletAnchors = true
      }
    }
  },
  computed: {
    getCurrentPicture() {
      const mobilePicture = this.mainImage.mobilePicture ? this.mainImage.mobilePicture : this.mainImage.picture
      return this.tabletAnchors ? mobilePicture : this.mainImage.picture
    },
    backgroundImages () {
      return this.images
    },
    mainImage () {
      return this.mainImages[this.mainImageIndex]
    },
    backgroundImagesPos () {
      let res = []
      while (res.length < this.backgroundImages.length) {
        let obj = {
          x: 0,
          y: 0,
          endX: rando(-100, -70),
          endY: rando(-100, -70),
          scale: 1
        }
        if (res.length === 0) {
          obj = {
            ...obj,
            x: rando(-220, -200),
            y: rando(-200, -150),
            endX: -120,
            endY: -120,
            scale: 1
          }
        } else if (res.length === 1) {
          obj = {
            ...obj,
            x: rando(-120, 120),
            y: rando(-120, 50),
            endX: 0,
            endY: -100,
            scale: 1
          }
        } else if (res.length === 2) {
          obj = {
            ...obj,
            x: rando(180, 200),
            y: rando(-220, -170),
            endX: 100,
            endY: -50,
            scale: 1
          }
        } else if (res.length === 3) {
          obj = {
            ...obj,
            x: rando(150, 200),
            y: rando(150, 200),
            endX: 150,
            endY: 30,
            scale: 1
          }
        } else if (res.length === 4) {
          obj = {
            ...obj,
            x: rando(-220, -180),
            y: rando(180, 200),
            endX: -90,
            endY: 100,
            scale: 1
          }
        } else if (res.length === 5) {
          obj = {
            ...obj,
            x: rando(-250, -220),
            y: rando(-30, 30),
            endX: -180,
            endY: 0,
            scale: 1
          }
        } else if (res.length === 6) {
          obj = {
            ...obj,
            x: rando(-70, -20),
            y: rando(-20, 0),
            endX: -80,
            endY: 100,
            scale: 1
          }
        } else if (res.length === 7) {
          obj = {
            ...obj,
            x: rando(20, 70),
            y: rando(-20, 70),
            endX: 50,
            endY: 100,
            scale: 1
          }
        }

        res = [
          ...res,
          obj
        ]
      }

      return res
    },
    imagesScrollPositions () {
      return this.backgroundImagesPos.map((o) => {
        return {
          x: easeInOutSine(this.scrollTop, o.x, o.endX - o.x, 1600),
          y: easeInOutSine(this.scrollTop, o.y, o.endY - o.y, 1600)
        }
      })
    },
    mainImageScale () {
      const scale = easeInQuad(this.scrollTop, 1, 0.45 - 1, 600)
      return scale >= 0.45 ? scale : 0.45
    },
  },
  watch: {
    "$route.query": function () {
      this.hideText = false
      this.hideImages = false
    }
  },
  mounted () {
    if (!this.defaultScroll) {
      this.handleScroll()
      this.intersectionObserver = new IntersectionObserver(([entry]) => {
        this.watchScroll = entry.isIntersecting
      })
      this.intersectionObserver.observe(this.$refs.root)

      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener("resize", this.checkTablet);
    }
    this.usedIphone = navigator.platform.includes('iPhone') || navigator.platform.includes('iPod')
  },
  beforeDestroy () {
    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.$refs.root)
    }
    //window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener("resize", this.checkTablet);
  },
  methods: {
    goToUrl (url) {
      this.$router.push(url)
    },
    getTextArr(text) {
      return getArrForTitle(text)
    },
    useLink(link) {
      if (link.includes('#')) {
        const anchor = link.split('#').pop();
        setTimeout(() => {
          document.querySelector(`#${anchor}`).scrollIntoView({
            behavior: 'smooth'
          });
        }, 500)
      } else {
        window.location.href = link
      }

    },
    pictureUrl (url) { return this.$absoluteImageUrl(url) },
    setupCarousel () {
      if (this.mainImages.length > 0 && !this.timer) {
        this.timer = setInterval(() => {
          this.changeImage(1)
        }, 5000)
      }
    },
    changeImage(step) {
      let nextIndex = this.mainImageIndex + step

      if (nextIndex >= this.mainImages.length) {
        this.mainImageIndex = 0
        this.restarted = true
        this.$nextTick(() => {
          this.restarted = false
        })
      } else if (nextIndex < 0) {
        this.mainImageIndex = this.mainImages.length - 1
        this.restarted = true
        this.$nextTick(() => {
          this.restarted = false
        })
      } else {
        this.mainImageIndex = nextIndex
        this.restarted = false
      }
    },
    handleSwitchPicture(step) {
      if (this.timer) {
        clearInterval(this.timer)
        this.changeImage(step)
        this.timer = setInterval(() => {
          this.changeImage(1)
        }, 5000)
      }
    },
    stopCarousel () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    checkTablet: debounce(function() {
      if (this.mediaQuery.matches) {
        this.tabletAnchors = true
      } else {
        this.tabletAnchors = false
      }
    }, 50),
    handleScroll: throttle(function () {
      const rect = this.$refs.root.getBoundingClientRect()
      const headerContent = this.$refs.headerContent.getBoundingClientRect()
      this.scrollTop = window.scrollY
      this.scrollTop = Math.abs(rect.y)

      if (this.watchScroll) {
        // this.hideText = rect.y < -20
        const { innerHeight, scrollY } = window
        this.hideText = innerHeight + scrollY - 50 > headerContent.height && window.scrollY > 0
        // this.hideText = this.scrollTop > 0

        // let scrollRatio = 1 - Math.abs(rect.y) / rect.height
        let scrollRatio = 1 - this.scrollTop / rect.height

        this.hideImages = scrollRatio <= 0.25

        if (scrollRatio < 0.45) {
          scrollRatio = 0.45
        }

        this.scrollRatio = scrollRatio
      }

      if (this.scrollTop > 10) {
        this.stopCarousel()
      } else {
        this.setupCarousel()
      }
    }, 50)
  }
}
